import i18n from '@/i18n';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const PackageSubscriptions = () => import('./views/Index.vue');
const PackageSubscriptionView = () => import('./views/PackageSubscriptionView.vue');

export default [
  {
    path: 'package-subscriptions',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.PackageSubscriptions`,
        component: PackageSubscriptions,
        meta: {
          title: i18n.global.t('packageSubscriptions.packageSubscriptions'),
        },
      },
      {
        path: 'current',
        name: `${PREFIX.INSPECTOR}.PackageSubscriptions.Current`,
        component: PackageSubscriptionView,
        meta: {
          title: i18n.global.t('packageSubscriptions.current'),
        },
        props: true,
      },
    ],
  },
];
